export default {
  // Details.tsx
  page_title: 'Activity Details',
  section_rules: 'Activity rules',
  section_terms: 'Terms and Conditions',

  // index.tsx
  no_activities: 'No activities',
  long_term: 'Long-term activities',
  badge_new: 'New',
  badge_hot: 'Hot',

  // category chips (FE-hardcoded; backend has no categories endpoint)
  cat_all: 'All',
  cat_slot: 'Slot',
  cat_live: 'Live Casino',
  cat_fishing: 'Fishing',
  cat_sport: 'Sports',
  cat_withdraw: 'Withdraw',
};
